import { FC, useEffect, useRef, useState } from "react";
import classNames from "classnames";

import { useBreakpoint } from "hooks/useBreakpoint";

import styles from "./select.module.scss";

export type TOption = {
  label: string;
  value: string;
};

interface ISelect {
  options: TOption[];
  className?: string;
  value: TOption;
  onSelect?: (selected: TOption) => void;
  breakpoint?: string;
}

export const Select: FC<ISelect> = ({
  options,
  value,
  className,
  onSelect,
  breakpoint = "desktop"
}) => {
  //  const { breakpoint } = useBreakpoint();
  const dropdownEl = useRef(null);
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    const handleClickOutside = ({ target }: MouseEvent): void => {
      if (
        !dropdownEl?.current ||
        !(dropdownEl?.current as Node).contains(target as Node)
      ) {
        setOpened(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const selectHandler = (option: TOption) => {
    setOpened(false);
    if (onSelect) {
      onSelect(option);
    }
  };

  return (
    <div
      className={classNames(styles.select, styles[breakpoint], className)}
      ref={dropdownEl}
    >
      <div
        className={styles.selected}
        onClick={() => setOpened((prev) => !prev)}
      >
        {value.label}
      </div>
      {opened && (
        <div className={styles.dropdown}>
          {options.map((option) => (
            <div
              key={option.value}
              className={styles.dropdownItem}
              onClick={() => selectHandler(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
